module.exports = __webpack_public_path__ + "static/elven_chain-85b8de551ab93f24bd6c4d8e2d03b860.jpeg";